module.exports = __webpack_public_path__ + "img/banner_cfm_1.0f8ea0eb.png";